import * as React from "react";
import { useEffect } from 'react'
import './App.css';
import './css/hover.css';

import { Admin, Resource, Sidebar } from 'react-admin';
import { addSearchMethod } from '@react-admin/ra-search';

import { dataProvider } from "./data/dataProvider";

import { AdminUserCreate, AdminUserEdit, AdminUserList, AdminUserShow } from "./panels/adminUsers/AdminUsers";
import _LoginPage from "./components/LoginPage";
import { AuthProvider } from "./auth/authProvider";
import { theme } from "./style/theme2";
// import { theme3 } from "./style/theme3";

import { i18nProvider } from "./i18n/i18nProvider";
import MyLayout from "./components/Layout";
// import Dashboard from "./panels/dashboard/Dashboard";
// import Reportstat from './panels/Reportstat';


import AccountTreeIcon from '@material-ui/icons/AccountTree';
import NatureIcon from '@material-ui/icons/Nature';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import AssessmentIcon from '@material-ui/icons/Assessment';
// import TimelineIcon from '@material-ui/icons/Timeline';
import BarChartIcon from '@mui/icons-material/BarChart';
// import ChatBubble from '@material-ui/icons/ChatBubble';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import FilterVintageIcon from '@material-ui/icons/FilterVintage';
import CategoryIcon from '@material-ui/icons/Category';
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt';
import InfoIcon from '@material-ui/icons/Info';
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WifiCalling3Icon from '@mui/icons-material/WifiCalling3';
import CallEndIcon from '@mui/icons-material/CallEnd';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupsIcon from '@mui/icons-material/Groups';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import CategoryTwoToneIcon from '@mui/icons-material/CategoryTwoTone';
import SdStorageIcon from '@mui/icons-material/SdStorage';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import SmsIcon from '@mui/icons-material/Sms';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

import { ROLES } from "./constants";
import { MenuCategories } from "./constants/menuCategories";
import { ProductCreate, ProductEdit, ProductList, ProductShow } from "./panels/product/Product";
import { ReportCreate, ReportEdit, ReportList, ReportShow } from "./panels/report/Report";
// import { ReportstatList } from "./panels/reportstat/Reportstat";


// import { BranchCreate, BranchEdit, BranchList, BranchShow } from "./panels/branch/Branch";
import { NeedCreate, NeedEdit, NeedList, NeedShow } from "./panels/needs/Needs";

import closeSidebarSaga from './closeSidebarSaga'

import customRoutes from './panels/custom/customRoutes';

import { ProductCategoryCreate, ProductCategoryEdit, ProductCategoryList, ProductCategoryShow } from "./panels/productCategory/ProductCategory";
import { NeedCategoryCreate, NeedCategoryEdit, NeedCategoryList, NeedCategoryShow } from "./panels/needCategory/NeedCategory";
import { UnitCreate, UnitEdit, UnitList, UnitShow } from "./panels/essentials/unit/Unit";
import { UnitProcessorCreate, UnitProcessorEdit, UnitProcessorList, UnitProcessorShow } from "./panels/essentials/unitProcessor/UnitProcessor";
// import { WhatsappCreate, WhatsappEdit, WhatsappList, WhatsappShow } from "./panels/whatsapp/Whatsapp";
import { StatusCreate, StatusEdit, StatusList, StatusShow } from "./panels/essentials/status/Status";
import { CustomerCreate, CustomerEdit, CustomerList, CustomerShow } from "./panels/crm/customer/Customer";
import { ContactCreate, ContactEdit, ContactList, ContactShow } from "./panels/crm/contact/Contact";


import { StatusLoadingCreate, StatusLoadingEdit, StatusLoadingList, StatusLoadingShow } from "./panels/essentials/statusLoading/StatusLoading";
import { LoadingRequestEdit, LoadingRequestList, LoadingRequestShow } from "./panels/loadingRequest/LoadingRequest";

import { PreferCallCreate, PreferCallEdit, PreferCallList, PreferCallShow } from "./panels/essentials/preferCall/PreferCall";
import { StatusCallCreate, StatusCallEdit, StatusCallList, StatusCallShow } from "./panels/essentials/statusCall/StatusCall";
import { PackageCreate, PackageEdit, PackageList, PackageShow } from "./panels/essentials/package/Package";
import { OrderTypeCreate, OrderTypeEdit, OrderTypeList, OrderTypeShow } from "./panels/essentials/orderType/OrderType";

import { RTL } from "./style/rtl";

import Notification from './firebase/Notification'
import { CustomerCategoryCreate, CustomerCategoryEdit, CustomerCategoryList, CustomerCategoryShow } from "./panels/crm/essentials/customerCategory/CustomerCategory";
import { ContactCategoryCreate, ContactCategoryEdit, ContactCategoryList, ContactCategoryShow } from "./panels/crm/essentials/contactCategory/ContactCategory";
import { CustomerPriorityCreate, CustomerPriorityEdit, CustomerPriorityList, CustomerPriorityShow } from "./panels/crm/essentials/customerPriority/CustomerPriority";
import { CustomerRatingCreate, CustomerRatingEdit, CustomerRatingList, CustomerRatingShow } from "./panels/crm/essentials/customerRating/CustomerRating";
import { EventList } from "./panels/event/Event";
import { StorageCreate, StorageList, StorageShow } from "./panels/essentials/storage/Storage";
import { ClueCreate, ClueEdit, ClueList, ClueShow } from "./panels/crm/clue/Clue";
import { ReminderCreate, ReminderEdit, ReminderList, ReminderShow } from "./panels/crm/reminder/Reminder";
import { SendSMSCreate, SendSMSEdit, SendSMSList, SendSMSShow } from "./panels/essentials/sms/SendSMS";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import InsightsIcon from '@mui/icons-material/Insights';
// import { isMobile, useMobileOrientation } from 'react-device-detect';



// import { addRealTimeMethodsBasedOnMercure } from "@react-admin/ra-realtime";
import { NotificationsList, NotificationsShow } from './panels/essentials/notifications/Notifications';
import { TransactionList, TransactionCreate, TransactionEdit, TransactionShow } from './panels/transaction/Transaction';
import PaidIcon from '@mui/icons-material/Paid';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
// import { addRealTimeMethodsBasedOnMercure } from '@react-admin/ra-realtime';
import { BaseUnitCreate, BaseUnitEdit, BaseUnitList, BaseUnitShow } from './panels/product/details/baseUnit/BaseUnit';
import { ProductUnitCreate, ProductUnitEdit, ProductUnitList, ProductUnitShow } from './panels/product/details/productUnit/ProductUnit';
import { RawMaterialCreate, RawMaterialEdit, RawMaterialList, RawMaterialShow } from './panels/product/details/rawMaterial/RawMaterial';
import { ProductCapacityCreate, ProductCapacityEdit, ProductCapacityList, ProductCapacityShow } from "./panels/productCapacity/ProductCapacity";
import { ReportProductionCreate, ReportProductionEdit, ReportProductionList, ReportProductionShow } from "./panels/reportProduction/ReportProduction";
// import { ReportInputProductCreate, ReportInputProductEdit, ReportInputProductList, ReportInputProductShow } from "./panels/reportInputProducts/ReportInputProducts";

const CustomSidebar = (props) => <Sidebar {...props} size={200} />;

// const realTimeDataProvider = addRealTimeMethodsBasedOnMercure(
//   // original dataProvider

//   dataProvider,
//   // Mercure hub url
//   "http://193.176.242.199:8085/.well-known/mercure",
//   // JWT token to authenticate against the Mercure Hub
//   "eyJhbGciOiJIUzI1NiJ9.eyJtZXJjdXJlIjp7InB1Ymxpc2giOlsiKiJdLCJzdWJzY3JpYmUiOlsiKiJdfX0.UpIm0R5Now5UkzTU-ityvUreYpNIdvERValXvpMXEPA"
// );
// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const dataProviderWithSearch = addSearchMethod(dataProvider, {
  'contact': {
    label: 'name',
    description: record =>
      // `${record.phoneNumbers[0].number}`,
      `${record.phoneNumbers.map(a => a.number)}`,

    customData: record =>
      `${record}`,

  },
  // 'need': {
  //   label: 'title',
  //   description: record =>
  //     `از طرف - ${record.ownerName}`,
  //   customData: record =>
  //     `${record}`,
  // },
  // 'storage': {
  //   label: 'title',
  //   description: record =>
  //     `- <a href=${record.url}>دریافت</a>`,
  // },


});

// const realTimeDataProvider = addRealTimeMethodsBasedOnMercure(
//   // original dataProvider
//   dataProviderWithSearch,
//   // Mercure hub url
//   'http://real.gazshop.ir:8420/.well-known/mercure',
//   // JWT token to authenticate against the Mercure Hub
//   'eyJhbGciOiJIUzI1NiJ9.eyJtZXJjdXJlIjp7InB1Ymxpc2giOlsiKiJdLCJzdWJzY3JpYmUiOlsiKiJdfX0.ReWuqm4tsPoV1SJzeMDan22aQ0UY9gLadFFo9DqbreM',
//   "real.gazshop.ir/adminpanel"
// );


// Initialize Firebase
const App = () => {
  useEffect(() => {

    //   OneSignal.init({
    //     appId: "be257c4b-bee4-4f60-937b-db364eae3a2e"
    //   });
  }, []);

  return (
    <RTL>
      <Admin
        customSagas={[closeSidebarSaga]}
        sidebar={CustomSidebar}

        customRoutes={customRoutes}
        loginPage={_LoginPage}
        dataProvider={dataProviderWithSearch}
        authProvider={AuthProvider}
        // isMobile ? MyTheme :
        theme={theme}
        i18nProvider={i18nProvider}
        title={process.env.REACT_APP_TITLE}
        layout={MyLayout}
      // dashboard={Dashboard}

      // dashboard={Dashboard}
      >
        {permissions => [
          <Resource name="notifications"
            show={NotificationsShow}
            list={NotificationsList}
            dataProvider={dataProvider}
            icon={<NotificationsActiveIcon />}
            options={{
              category: MenuCategories.notifications, label: 'اعلان ', permissions: [
                ROLES.SUPER_ADMIN,
                ROLES.HR_ADMIN,
                ROLES.USERS_ADMIN,
                ROLES.UNIT_ADMIN,
                ROLES.MARKETING_ADMIN,
                ROLES.USER_EXPERIMENTAL,
                ROLES.ANBAAR_ADMIN,
                ROLES.SALE_ADMIN,
              ]
            }}
          />
          ,
          <Resource
            name="need"
            dataProvider={dataProvider}
            list={NeedList}
            create={NeedCreate}
            edit={NeedEdit}
            show={NeedShow}
            icon={<LiveHelpIcon />}
            options={{
              category: MenuCategories.need, label: ' درخواست‌', permissions: [
                ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.MARKETING_ADMIN, ROLES.USER_EXPERIMENTAL, ROLES.SUPER_ADMIN]
            }}
          />
          ,


          // <Resource
          //   name="needNotes"
          //   dataProvider={dataProvider}
          // />
          // ,
          <Resource
            name="loadingRequest"
            dataProvider={dataProvider}
            list={LoadingRequestList}
            // create={LoadingRequestCreate}
            edit={LoadingRequestEdit}
            show={LoadingRequestShow}
            icon={<LocalShippingIcon />}
            options={{ category: MenuCategories.loading, label: ' سفارش بار ', permissions: [ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.SUPER_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.USER_EXPERIMENTAL, ROLES.MARKETING_ADMIN] }}
          />

          ,
          <Resource
            name="report"
            dataProvider={dataProvider}
            list={ReportList}
            create={ReportCreate}

            edit={ReportEdit}
            show={ReportShow}
            icon={<AssessmentIcon />}
            options={{ category: MenuCategories.reportInsert, label: 'ثبت موجودی', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.USER_EXPERIMENTAL, ROLES.MARKETING_ADMIN] }}
          />,
          <Resource
            name="reportProduction"
            dataProvider={dataProvider}
            list={ReportProductionList}
            create={ReportProductionCreate}

            edit={ReportProductionEdit}
            show={ReportProductionShow}
            icon={< ProductionQuantityLimitsIcon style={{ color: "#a1a1a1" }} />}

            options={{ category: MenuCategories.reportProductionInsert, label: 'ثبت موجودی تولید', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN] }}
          />
          // ,
          // <Resource
          //   name="reportInputProduct"
          //   dataProvider={dataProvider}
          //   list={ReportInputProductList}
          //   create={ReportInputProductCreate}

          //   edit={ReportInputProductEdit}
          //   show={ReportInputProductShow}
          //   icon={<AssessmentIcon />}
          //   options={{ category: MenuCategories.reportInputProductInsert, label: 'ثبت انبار ورودی', permissions: [ROLES.SUPER_ADMIN] }}
          // />
          ,

          < Resource
            name="reportstat"
            dataProvider={dataProvider}
            // list={ReportstatList}
            icon={< WarehouseIcon />}
            options={{ category: MenuCategories.report, label: 'موجودی‌ ', permissions: [ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.SUPER_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.MARKETING_ADMIN] }}
          />,
          <Resource
            name="customer"
            dataProvider={dataProvider}
            list={CustomerList}
            create={CustomerCreate}
            edit={
              (permissions?.includes(ROLES.SUPER_ADMIN)
                || permissions?.includes(ROLES.MANAGER_CRM)
                || permissions?.includes(ROLES.SALE_ADMIN)
                || permissions?.includes(ROLES.SALE_CRM_ADMIN))
                ? CustomerEdit : null}
            show={CustomerShow}
            icon={<GroupsIcon />}
            options={{
              category: MenuCategories.crm, label: ' مشتری', permissions: [
                ROLES.SUPER_ADMIN,
                ROLES.MANAGER_CRM,
                ROLES.SALE_CRM_ADMIN,
                ROLES.UNIT_CRM_USER,
                ROLES.USER_CRM_SIMPLE,

              ]
            }}
          />

          ,
          <Resource
            name="contact"
            dataProvider={dataProvider}
            list={ContactList}
            create={ContactCreate}
            edit={ContactEdit}
            show={ContactShow}
            icon={<ContactPhoneIcon />}
            options={{
              category: MenuCategories.crm, label: ' مخاطب', permissions: [
                ROLES.SUPER_ADMIN,
                ROLES.MANAGER_CRM,
                ROLES.SALE_CRM_ADMIN,
                ROLES.UNIT_CRM_USER,
                ROLES.USER_CRM_SIMPLE,

              ]
            }}
          />
          ,
          <Resource
            name="clue"
            dataProvider={dataProvider}
            list={ClueList}
            create={ClueCreate}
            edit={ClueEdit}
            show={ClueShow}
            icon={<SavedSearchIcon />}
            options={{
              category: MenuCategories.crm, label: ' سرنخ‌', permissions: [
                ROLES.SUPER_ADMIN,
                ROLES.MANAGER_CRM,
                ROLES.SALE_CRM_ADMIN,
                ROLES.UNIT_CRM_USER,
                ROLES.USER_CRM_SIMPLE,

              ]
            }}
          />
          ,
          <Resource
            name="reminder"
            dataProvider={dataProvider}
            list={ReminderList}
            create={ReminderCreate}
            edit={ReminderEdit}
            show={ReminderShow}
            icon={<AccessAlarmsIcon />}
            options={{
              category: MenuCategories.tools, label: 'یادآوری‌', permissions: [
                ROLES.SUPER_ADMIN,
                ROLES.MANAGER_CRM,
                ROLES.SALE_CRM_ADMIN,
                ROLES.UNIT_CRM_USER,
                ROLES.USER_CRM_SIMPLE,

              ]
            }}
          />

          ,

          <Resource name="storage"
            create={(permissions?.includes(ROLES.SUPER_ADMIN)
              || permissions?.includes(ROLES.USERS_ADMIN)
              || permissions?.includes(ROLES.SALE_ADMIN)) ? StorageCreate : null}

            list={StorageList}
            show={StorageShow}
            dataProvider={dataProvider}
            icon={<SdStorageIcon />}
            options={{ category: MenuCategories.tools, label: 'مخزن فایل‌ ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.USER_EXPERIMENTAL, ROLES.MARKETING_ADMIN] }}
          />
          ,
          < Resource
            name="chat"
            dataProvider={dataProvider}
            icon={< RocketLaunchIcon />}
            options={{ category: MenuCategories.tools, label: 'پیام‌رسان ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN, ROLES.USER_EXPERIMENTAL, ROLES.MARKETING_ADMIN] }}
          />
          ,
       
          <Resource
            name="transaction"
            dataProvider={dataProvider}
            list={TransactionList}
            create={TransactionCreate}
            edit={TransactionEdit}
            show={TransactionShow}
            icon={<PaidIcon />}
            options={{ category: MenuCategories.crm, label: 'تراکنش‌‌', permissions: [ROLES.SUPER_ADMIN, ROLES.USERS_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="product"
            dataProvider={dataProvider}
            list={ProductList}
            create={(permissions?.includes(ROLES.SUPER_ADMIN)
              || permissions?.includes(ROLES.USERS_ADMIN)
              || permissions?.includes(ROLES.SALE_ADMIN)) ? ProductCreate : null}
            edit={(permissions?.includes(ROLES.SUPER_ADMIN || ROLES.SALE_ADMIN)
              || permissions?.includes(ROLES.USERS_ADMIN)
              || permissions?.includes(ROLES.SALE_ADMIN)
            ) ? ProductEdit : null}
            show={ProductShow}
            icon={<FilterVintageIcon />}
            options={{ category: MenuCategories.production, label: 'محصولات', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN] }}
          />


          ,
          <Resource name="eventPanel"
            list={EventList}
            // edit={EventEdit}
            // create={EventCreate}
            dataProvider={dataProvider}
            icon={<MilitaryTechIcon />}
            options={{ category: MenuCategories.tools, label: 'تقویم ', permissions: [ROLES.SUPER_ADMIN] }}
          />,
     
          < Resource
            name="biNeed"
            dataProvider={dataProvider}
            icon={< InsightsIcon style={{ color: "#0eda41" }} />}
            options={{ category: MenuCategories.bi, label: 'تحلیل درخواست‌', permissions: [ROLES.ROOT, ROLES.SUPER_ADMIN] }}
          />,
          < Resource
            name="productCapacity"
            list={ProductCapacityList}
            create={ProductCapacityCreate}
            edit={ProductCapacityEdit}
            show={ProductCapacityShow}

            dataProvider={dataProvider}
            icon={< ProductionQuantityLimitsIcon style={{ color: "#e32134" }} />}
            options={{ category: MenuCategories.production, label: 'ظرفیت تولید', permissions: [ROLES.SUPER_ADMIN] }}
          />,

          // < Resource
          //   name="biNeed"
          //   dataProvider={dataProvider}
          //   icon={< InsightsIcon style={{ color: "#0eda41" }} />}
          //   options={{ category: MenuCategories.bi, label: 'تحلیل درخواست‌', permissions: [ROLES.SUPER_ADMIN] }}
          // />,
          < Resource
            name="biLoad"
            dataProvider={dataProvider}
            icon={< BarChartIcon style={{ color: "#9c247c" }} />}
            options={{ category: MenuCategories.bi, label: 'تحلیل سفارش‌', permissions: [ROLES.SUPER_ADMIN] }}
          />,
          <Resource
          name="adminUsers"
          dataProvider={dataProvider}
          list={AdminUserList}
          create={AdminUserCreate}
          edit={AdminUserEdit}
          show={AdminUserShow}
          icon={<SupervisorAccountIcon />}
          options={{ category: MenuCategories.res, label: 'همکاران', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
        />,
          <Resource
            name="unit"
            dataProvider={dataProvider}
            list={UnitList}
            create={UnitCreate}
            edit={UnitEdit}
            show={UnitShow}
            icon={<NatureIcon />}
            options={{ category: MenuCategories.res, label: ' بخش های مجموعه', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,

          <Resource
            name="unitProcessor"
            dataProvider={dataProvider}
            list={UnitProcessorList}
            create={UnitProcessorCreate}
            edit={UnitProcessorEdit}
            show={UnitProcessorShow}
            icon={<AccountTreeIcon />}
            options={{ category: MenuCategories.res, label: 'زیر بخش های مجموعه', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          // <Resource
          //   name="whatsapp"
          //   dataProvider={dataProvider}
          //   list={WhatsappList}
          //   create={WhatsappCreate}
          //   edit={WhatsappEdit}
          //   show={WhatsappShow}
          //   icon={<AccountTreeIcon />}
          //   options={{ category: MenuCategories.whatsapp, label: 'اکانت‌های واتس‌اپ', permissions: [ROLES.ROOT] }}
          // />
          // ,


          <Resource
            name="status"
            dataProvider={dataProvider}
            list={StatusList}
            create={StatusCreate}
            edit={StatusEdit}
            show={StatusShow}
            icon={<InfoIcon />}
            options={{ category: MenuCategories.res, label: 'وضعیت درخواست ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="statusLoading"
            dataProvider={dataProvider}
            list={StatusLoadingList}
            create={StatusLoadingCreate}
            edit={StatusLoadingEdit}
            show={StatusLoadingShow}
            icon={<LocalShippingIcon />}
            options={{ category: MenuCategories.res, label: 'وضعیت سفارش بار ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="package"
            dataProvider={dataProvider}
            list={PackageList}
            create={PackageCreate}
            edit={PackageEdit}
            show={PackageShow}
            icon={<CategoryIcon />}
            options={{ category: MenuCategories.rescrm, label: 'بسته بندی', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="orderType"
            dataProvider={dataProvider}
            list={OrderTypeList}
            create={OrderTypeCreate}
            edit={OrderTypeEdit}
            show={OrderTypeShow}
            icon={<AddShoppingCartIcon />}
            options={{ category: MenuCategories.rescrm, label: 'دسته بندی سفارش مشتری', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="needCategory"
            dataProvider={dataProvider}
            list={NeedCategoryList}
            create={NeedCategoryCreate}
            edit={NeedCategoryEdit}
            show={NeedCategoryShow}
            icon={<ViewQuiltIcon />}
            options={{ category: MenuCategories.res, label: 'نوع درخواست  ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,

          <Resource
            name="productCategory"
            dataProvider={dataProvider}
            list={ProductCategoryList}
            create={ProductCategoryCreate}
            edit={ProductCategoryEdit}
            show={ProductCategoryShow}
            icon={<CategoryIcon />}
            options={{ category: MenuCategories.res, label: 'دسته محصولات', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="baseUnit"
            dataProvider={dataProvider}
            list={BaseUnitList}
            create={BaseUnitCreate}
            edit={BaseUnitEdit}
            show={BaseUnitShow}
            icon={<NatureIcon />}
            options={{ category: MenuCategories.res, label: 'واحد‌ متریک استاندارد', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="productUnit"
            dataProvider={dataProvider}
            list={ProductUnitList}
            create={ProductUnitCreate}
            edit={ProductUnitEdit}
            show={ProductUnitShow}
            icon={<NatureIcon />}
            options={{ category: MenuCategories.res, label: 'واحد‌ فرعی سازمان', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="rawMaterial"
            dataProvider={dataProvider}
            list={RawMaterialList}
            create={RawMaterialCreate}
            edit={RawMaterialEdit}
            show={RawMaterialShow}
            icon={<NatureIcon />}
            options={{ category: MenuCategories.res, label: 'مواد اولیه', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="preferCall"
            dataProvider={dataProvider}
            list={PreferCallList}
            create={PreferCallCreate}
            edit={PreferCallEdit}
            show={PreferCallShow}
            icon={<WifiCalling3Icon />}
            options={{ category: MenuCategories.rescrm, label: 'اولویت تماس ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="statusCall"
            dataProvider={dataProvider}
            list={StatusCallList}
            create={StatusCallCreate}
            edit={StatusCallEdit}
            show={StatusCallShow}
            icon={<CallEndIcon />}
            options={{ category: MenuCategories.rescrm, label: 'وضعیت تماس ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="customerCategory"
            dataProvider={dataProvider}
            list={CustomerCategoryList}
            create={CustomerCategoryCreate}
            edit={CustomerCategoryEdit}
            show={CustomerCategoryShow}
            icon={<CategoryIcon />}
            options={{ category: MenuCategories.rescrm, label: 'دسته‌بندی مشتری ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="contactCategory"
            dataProvider={dataProvider}
            list={ContactCategoryList}
            create={ContactCategoryCreate}
            edit={ContactCategoryEdit}
            show={ContactCategoryShow}
            icon={<CategoryTwoToneIcon />}
            options={{ category: MenuCategories.rescrm, label: 'دسته‌بندی مخاطب ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />
          ,
          <Resource
            name="customerPriority"
            dataProvider={dataProvider}
            list={CustomerPriorityList}
            create={CustomerPriorityCreate}
            edit={CustomerPriorityEdit}
            show={CustomerPriorityShow}
            icon={<LowPriorityIcon />}
            options={{ category: MenuCategories.rescrm, label: 'اولویت‌بندی مشتری ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
            name="customerRating"
            dataProvider={dataProvider}
            list={CustomerRatingList}
            create={CustomerRatingCreate}
            edit={CustomerRatingEdit}
            show={CustomerRatingShow}
            icon={<MilitaryTechIcon />}
            options={{ category: MenuCategories.rescrm, label: 'رتبه مشتری ', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
          />,
          <Resource
          name="sendSMS"
          dataProvider={dataProvider}
          list={SendSMSList}
          create={SendSMSCreate}
          edit={SendSMSEdit}
          show={SendSMSShow}
          icon={<SmsIcon />}
          options={{ category: MenuCategories.sendSMS, label: ' ارسال گروهی', permissions: [ROLES.SUPER_ADMIN, ROLES.SALE_ADMIN] }}
        />,



        ]}

      </Admin>
      <Notification />

    </RTL>
  )
};

export default App;